import { ChangeDetectionStrategy, Component } from '@angular/core';
import { OrderSummaryBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderSummaryComponent extends OrderSummaryBaseComponent {}
